import { useBotInfo } from "../contexts/BotContext";
import "./Spinner.css";

interface SpinnerProps {
  size?: "small" | "medium" | "large";
  text?: string;
}

function Spinner({ size = "medium", text }: SpinnerProps) {
  const { botInfo } = useBotInfo();

  return (
    <div className={`spinner-container spinner-${size}`}>
      <div className="spinner">
        <div className="spinner-circle"></div>
        <div className="spinner-circle-inner"></div>
        {botInfo?.avatarURL ? (
          <img
            src={botInfo.avatarURL}
            alt="Bot Avatar"
            className="spinner-avatar-icon"
          />
        ) : (
          <div className="spinner-icon">🤖</div>
        )}
      </div>
      {text && <p className="spinner-text">{text}</p>}
    </div>
  );
}

export default Spinner;
